module.exports = __webpack_public_path__ + "static/unicorn1-a570bb3194c2f0be3747f277dabfb28a.png";